/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-08T09:34:20+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   Matze
* @Last modified time: 2016-09-26T12:54:12+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import buttonProps from './../../../utilities/buttonProps';
import AIconInline, {NORMAL} from './../../icons/components/AIconInline';

/**
 * AButtonIcon - just a icon as button
**/
class AButtonIcon extends Component {
  /**
     * react render() <AButtonIcon>
     *
     * @return {object}
     */
  render() {
    const {
      onPress,
      icon,
      iconSize,
      children = icon,
      active, // eslint-disable-line no-unused-vars
      visualState,
      ...other
    } = this.props;
    return (
      <button
        {...other}
        className={`a-button a-button-icon ${visualState}`}
        onClick={onPress}
      >
        <AIconInline
          icon={children}
          size={iconSize}
        />
      </button>
    );
  }
}

AButtonIcon.propTypes = {
  onPress: PropTypes.func,
  visualState: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.string,
  active: PropTypes.bool,
  iconSize: AIconInline.propTypes.size,
};
AButtonIcon.defaultProps = {
  icon: 'search',
  iconSize: NORMAL,
};
export default buttonProps(AButtonIcon);

